<!--
 * @Description: 机构审核详情-基本信息面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 16:58:14
-->
<template>
  <div class="baseinfo-panel-main">
    <el-form class="baseInfoForm" ref="baseInfoForm" :model="baseInfoDO.institution" :rules="rules" 
      label-position="top" label-width="100px">
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="省：" prop="province">
            <el-select size="small" style="width: 100%" v-model="baseInfoDO.institution.province" placeholder="请选择" 
              :disabled="readonly" filterable>
              <el-option v-for="item in baseInfoDO.provinceList" :key="item.id" :label="item.name" 
                :value="item.name" />
            </el-select>
        	</el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="市：" prop="city">
            <el-select size="small" style="width: 100%" v-model="baseInfoDO.institution.city" placeholder="请选择" 
              :disabled="readonly" filterable>
              <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="县：" prop="county">
            <el-select size="small" style="width: 100%" v-model="baseInfoDO.institution.county" placeholder="请选择" 
              :disabled="readonly" filterable>
              <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="名称：" prop="name">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.name" placeholder="请输入机构名称" 
              :readonly="readonly" minlength="3">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="机构地址：" prop="addr">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.addr" placeholder="请输入机构地址" 
              :readonly="readonly" oninput="if (value.length > 100) value = value.slice(0, 100)" />
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="保证金（单位：元）：" prop="deposit">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.deposit" 
              placeholder="请输入保证金" :readonly="readonly" />
          </el-form-item>
        </el-col>
      </el-row>
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="统一社会信用代码：" prop="bizLicense">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.bizLicense" 
              placeholder="请输入统一社会信用代码" :readonly="readonly"
							oninput="if (value.length > 30) value = value.slice(0, 30)">
            </el-input>
          </el-form-item>
        </el-col>
				<el-col :span="8" style="text-align: left">
          <el-form-item label="法人代表姓名：" prop="legalPerson">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.legalPerson" 
              placeholder="请输入法人代表姓名" :readonly="readonly"
              oninput="if (value.length > 20) value = value.slice(0, 20)" />
          </el-form-item>
        </el-col>
				<el-col :span="8" style="text-align: left">
          <el-form-item label="机构编号：" prop="identifier">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.identifier"
              placeholder="请输入机构编号" :readonly="readonly"
              minlength="2" oninput="if (value.length > 20) value = value.slice(0, 20)" />
          </el-form-item>
        </el-col>
			</el-row>
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="联系人：" prop="contact">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.contact" 
              placeholder="请输入联系人姓名" :readonly="readonly"
              oninput="if (value.length > 20) value = value.slice(0, 20)" />
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="联系电话：" prop="contactNum">
            <el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.contactNum" 
              placeholder="请输入联系电话" :readonly="readonly"
              oninput="if (value.length > 12) value = value.slice(0, 12)" />
          </el-form-item>
        </el-col>
				<el-col :span="8" style="text-align: left">
          <el-row style="width: 100%" type="flex" justify="space-between" align="middle">
            <el-form-item label="Logo：" prop="logoPath">
              <div :class="baseInfoDO.institution.logoPath && baseInfoDO.institution.logoPath.length 
                ? 'bk-has-logo' : ''">
                <el-image v-if="baseInfoDO.institution.logoPath && baseInfoDO.institution.logoPath.length" 
                  :style="{width: '64px', height: '64px',}" 
                  :src="logoPath" :preview-src-list="previewImgList" fit="contain">
                </el-image>
                <span v-else>无</span>
              </div>
            </el-form-item>
          </el-row>
        </el-col>
			</el-row>
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
				<el-col :span="16" style="text-align: left">
					<el-row :gutter="50" type="flex" justify="space-between">
						<el-col :span="12" style="text-align: left">
							<el-form-item label="客服：" prop="csr">
								<el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.csr" 
                  placeholder="请输入客服姓名" :readonly="readonly"
									oninput="if (value.length > 20) value = value.slice(0, 20)" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="text-align: left">
							<el-form-item label="客服电话：" prop="csTeleno">
								<el-input size="small" style="width: 100%" v-model="baseInfoDO.institution.csTeleno" 
                  placeholder="请输入客服电话" :readonly="readonly"
                  oninput="if (value.length > 12) value = value.slice(0, 12)" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="50" type="flex" justify="space-between">
						<el-col :span="24" style="text-align: left">
							<el-form-item style="width: 100%" label="服务说明：" prop="remark">
								<el-input style="width: 100%" v-model="baseInfoDO.institution.remark" 
                  placeholder="请说明本机构服务的范围，例：本机构服务于医院的XX科室/XX楼等" :readonly="readonly" 
									type="textarea" :rows="3" oninput="if (value.length > 100) value = value.slice(0, 100)" />
							</el-form-item>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="营业执照：" prop="picPath">
            <div :class="baseInfoDO.institution.licensePath && baseInfoDO.institution.licensePath.length 
              ? 'bk-has-license' : ''">
              <el-image v-if="baseInfoDO.institution.licensePath && baseInfoDO.institution.licensePath.length" 
                :style="{width: '100%', height: '100%',}" 
                :src="picPath" :preview-src-list="previewImgList" fit="contain">
              </el-image>
              <span v-else>无</span>
            </div>
          </el-form-item>
				</el-col>
			</el-row>
		</el-form>
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="modeReview" :status="btnStatus" @btnpressed="handleInstReviewBtnSelection" />
    </div>
  </div>
</template>

<script>
import instReviewStore from './InstReviewStore.js'

let InstBaseInfoPanel = {
  name: 'InstReviewBaseInfoPanel',
  instReviewStore,

  data() {
    return {
      btnStatus: {'prev': false, 'next': true, 'submit': false},      
      rules: {},
      cityList: [],
      countyList: [],
    }
  },

  computed: {
    modeReview() {
      return instReviewStore.state.mode;
    },

    baseInfoDO() {
      if (Object.keys(instReviewStore.state.baseInfoDO.institution).length == 0) this.clearFormVaild();
      return instReviewStore.state.baseInfoDO;
    },

    readonly() {
      return instReviewStore.state.mode == 'details';
    },

    logoPath() {
      if (instReviewStore.state.logoFile) return this.commonUtil.file2Url(instReviewStore.state.logoFile);
      return this.baseInfoDO.institution.logoPath
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.logoPath)
        : require('@/assets/common/img-common-chooseimg.png');
    },

    logoFile() {
      return instReviewStore.state.logoFile ? instReviewStore.state.logoFile : null;
    },

    picPath() {
      if (instReviewStore.state.picFile) return this.commonUtil.file2Url(instReviewStore.state.picFile);
      return this.baseInfoDO.institution.licensePath
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.licensePath)
        : require('@/assets/common/img-common-chooseimg.png');
    },

    picFile() {
      return instReviewStore.state.picFile ? instReviewStore.state.picFile : null;
    },

    previewImgList() {
      let imgList = [];
      if (this.baseInfoDO.institution.logoPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.logoPath));
      }
      if (this.baseInfoDO.institution.licensePath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.licensePath));
      }
      return imgList;
    }
  },

  methods: {
		handleInstReviewBtnSelection(oprReview) {
			if (this.modeReview == 'details' || oprReview != 'next')  {
					this.$emit("panel-operate", oprReview);
					return true;
			}
			this.$refs.baseInfoForm.validate((valid) => {
				if (!valid) return false;
				else {
					this.$emit("panel-operate", oprReview);
					return true;
				}
			});
		},

    clearFormVaild() {
    	this.$nextTick(() => {
        this.$refs["baseInfoForm"].clearValidate();
      });
		},
  },

  destroyed() {
    //销毁的时候同步数据
    instReviewStore.commit('changeBaseInfoDO', this.baseInfoDO);
  },
}
export default InstBaseInfoPanel
</script>

<style scoped>
.baseinfo-panel-main {
	margin: 20px 0;
}

.baseInfoForm {
  margin-bottom: 60px;
}

.bk-has-logo {
  width:64px;
  height:64px;
  background-color:#EBEEF2;
  display:flex;
  justify-content:center;
  align-items:center;
}

.bk-has-license {
  width: 100%;
  height:162px;
  background-color:#EBEEF2;
  display:flex;
  justify-content:center;
  align-items:center;
}
</style>

<style>
.baseinfo-panel-main .el-form--label-top .el-form-item__label {
	padding: 0px;
  line-height: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/InstReviewDetails/InstReviewBaseInfoPanel.vue